/* eslint-disable no-inline-comments, @stylistic/max-len */
import type {ComponentType} from 'react';

import dynamic from 'next/dynamic';

import type {Config} from 'types/payload-types';

const Faq = dynamic(async () => (await import(/* webpackChunkName: "Faq" */'./Faq')).Faq);
const FeatureGrid = dynamic(async () => (await import(/* webpackChunkName: "FeatureGrid" */'./FeatureGrid')).FeatureGrid);
const Hero = dynamic(async () => (await import(/* webpackChunkName: "Hero" */'./Hero')).Hero);
const Quote = dynamic(async () => (await import(/* webpackChunkName: "Quote" */'./Quote')).Quote);
const Steps = dynamic(async () => (await import(/* webpackChunkName: "Steps" */'./Steps')).Steps);
const Text = dynamic(async () => (await import(/* webpackChunkName: "Text" */'./Text')).Text);
const TextImage = dynamic(async () => (await import(/* webpackChunkName: "TextImage" */'./TextImage')).TextImage);

type BlockComponentMap = {
    [K in keyof Config['blocks']]: ComponentType<any>;
};

export const BlockMap: BlockComponentMap = {
    faq: Faq,
    'feature-grid': FeatureGrid,
    hero: Hero,
    quote: Quote,
    steps: Steps,
    text: Text,
    'text-image': TextImage
};